import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-start",
  "use": "icon-start-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-start\"><path d=\"M512 32a480 480 0 1 1 0 960 480 480 0 0 1 0-960zM512 128a384 384 0 1 0 0 768A384 384 0 0 0 512 128zM428.16 320.704a32 32 0 0 1 18.048 5.504l234.368 159.36a32 32 0 0 1 0 52.928l-234.368 159.296a32 32 0 0 1-49.984-26.496V352.704a32 32 0 0 1 32-32z\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol